import { render, staticRenderFns } from "./phone-query.vue?vue&type=template&id=403e4740&scoped=true"
import script from "./phone-query.vue?vue&type=script&lang=ts"
export * from "./phone-query.vue?vue&type=script&lang=ts"
import style0 from "./phone-query.vue?vue&type=style&index=0&id=403e4740&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403e4740",
  null
  
)

export default component.exports